import { render } from "./Fade.vue?vue&type=template&id=12c6b146&scoped=true"
import script from "./Fade.vue?vue&type=script&lang=js"
export * from "./Fade.vue?vue&type=script&lang=js"

import "./Fade.vue?vue&type=style&index=0&id=12c6b146&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c6b146"]])

export default __exports__